import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=cd7a31d8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Footer.css?vue&type=style&index=0&id=cd7a31d8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7a31d8",
  null
  
)

export default component.exports